export default __webpack_public_path__ + "static/media/vision.186a6e6d.jpg";